import { render, staticRenderFns } from "./wechatMarketing.vue?vue&type=template&id=3cad68d4&scoped=true"
import script from "./wechatMarketing.vue?vue&type=script&lang=js"
export * from "./wechatMarketing.vue?vue&type=script&lang=js"
import style0 from "./wechatMarketing.vue?vue&type=style&index=0&id=3cad68d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad68d4",
  null
  
)

export default component.exports